import { Provider } from "./provider/Provider";

const IletisimService = {
  mesajListesi: ({ start, limit, order }) => {
    return Provider({
      start,
      limit,
      order,
      methodName: "Module/Iletisim/MesajListesi",
    });
  },
  freeQuoteList: ({ start, limit, order }) => {
    return Provider({
      start,
      limit,
      order,
      methodName: "Module/Iletisim/FreeQuote/FreeQuoteList",
    });
  },
  mesajKaldir: (mesajCode) => {
    return Provider({
      mesajCode,
      methodName: "Module/Iletisim/MesajKaldir",
    });
  },
};

export default IletisimService;
